import {
  Button,
  Header,
  Table,
} from '@cloudscape-design/components';
import { projectFromFirestore } from '@parallel-fluidics/shared/models/projects';
import {
  collection,
  getFirestore,
  orderBy,
  where,
} from 'firebase/firestore';
import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import AddProjectModal from '../../components/Projects/addProjectModal';
import useCustomInfiniteQuery from '../../hooks/use-customInfiniteQuery';

export default function InternalProjectsList() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [openAddProjectModal, setOpenAddProjectModal] = useState(false);

  const queryParams = useMemo(() => [
    collection(getFirestore(), 'projects'),
    where('isInternal', '==', true),
    orderBy('name', 'desc'),
  ], []);
  const {
    pageData,
    isFetchingNextPage,
    CustomPagination,
    refetch,
  } = useCustomInfiniteQuery({
    queryKey: 'getInternalProjects',
    queryParams,
    pageSize: 25,
    transformData: projectFromFirestore,
  });

  return (
    <>
      <Table
        header={(
          <Header
            variant="awsui-h1-sticky"
            actions={(
              <Button onClick={() => setOpenAddProjectModal(true)}>
                Create a Internal Project
              </Button>
          )}
          >
            Internal Projects
          </Header>
      )}
        variant="full-page"
        stickyHeader
        loading={isFetchingNextPage}
        items={pageData}
        resizableColumns
        empty={<div>No resources</div>}
        pagination={<CustomPagination />}
        columnDefinitions={[
          {
            id: 'name',
            header: 'Project ID',
            // eslint-disable-next-line react/no-unstable-nested-components
            cell: (item) => (
              <Button
                variant="inline-link"
                onClick={() => navigate(`/projects/${item.id}?${searchParams.toString()}`)}
              >
                {item.name}
              </Button>
            ),
            width: 240,
          },
          {
            id: 'description',
            header: 'Description',
            cell: (item) => item.description,
          },
          {
            id: 'notes',
            header: 'Notes',
            cell: (item) => item.notes,
          },
        ]}
      />
      {openAddProjectModal && (
        <AddProjectModal
          isInternal
          open={openAddProjectModal}
          onClose={() => setOpenAddProjectModal(false)}
          onSuccess={refetch}
        />
      )}
    </>
  );
}
